// src/pages/Blog.jsx
import { Link } from 'react-router-dom';
import { useState } from 'react';
import bgImage from '../Assets/TeamandOthers/Blog-bb7.webp';
import doctorImage from "../Assets/TeamandOthers/DR1.png";
import blog1 from '../Assets/Services/PD.webp';
import blog2 from '../Assets/Services/GC.webp';
import blog3 from '../Assets/Services/Endodontic.jpeg';
import blog4 from '../Assets/Services/LD.webp';
import blog5 from '../Assets/Services/C&B.webp';
import blog6 from '../Assets/Services/Dentures.webp';



// Mock blog data (you can later fetch from API or CMS)
const blogPosts = [
  {
    id: 1,
    title: "Difference Between Antiseptic and Antibacterial Mouthwash",
    excerpt: "You might find yourself spinning in the aisles of your local supermarket or drugstore when you browse the wide variety of mouthwashes and oral care products on offer. Different benefits are outlined o",
    image: blog1,
    category: "Health",
    date: "December  27 , 2021",
    readTime: "6 min read",
  },
  {
    id: 2,
    title: "The Connection Between Oral Health And Strokes",
    excerpt: "There is an essential connection between oral health and strokes that most people do not realize. It is estimated that over a million bacteria live in your mouth, and some of these bacteria are linked",
    image: blog2,
    category: "Tips",
    date: "December  21 , 2021",
    readTime: "5 min read",
  },
  {
    id: 3,
    title: "How To Rebalance The PH Of Your Mouth",
    excerpt: "In order to keep your teeth healthy, your saliva is essential. In addition to coating your teeth with calcium, fluoride, and phosphate, this rarely recognized substance works to keep the outer layer o",
    image: blog3,
    category: "Health",
    date: "December  13 , 2021",
    readTime: "8 min read",
  },
  {
    id: 4,
    title: "Smooth Surface Cavities",
    excerpt: "Did you know? Cavities can form anywhere on a tooth. The bacteria that cause cavities can attack the root, the top of a tooth, and even the sides if they are exposed. Often, a smooth surface cavity ap",
    image: blog4,
    category: "Implants",
    date: "November  24 , 2021",
    readTime: "7 min read",
  },
  {
    id: 5,
    title: "Myths about Bad Breath",
    excerpt: "No one would want to have a bad breath, it makes us feel conscious, uncomfortable and make any conversational situation awkward. Well, you&rsquo;re not the only one to feel this way and this generally",
    image: blog5,
    category: "Technology",
    date: "November  24 , 2021",
    readTime: "6 min read",
  },
  {
    id: 6,
    title: "Oil Pulling and It's Benefits",
    excerpt: "Using oil as a mouthwash to cleanse your mouth of bacteria and promote oral health is an ancient ayurvedic practice that promotes good oral health. Oil pulling has been shown to kill bacteria in the m",
    image: blog6,
    category: "Endodontics",
    date: "October  29 , 2021",
    readTime: "5 min read",
  },
];

const categories = [
  "All", "Health", "Tips", "Implants", "Technology", "Pediatric", "Cosmetic", "Orthodontics"
];

const Blog = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  // Filter posts (simple client-side filtering)
  const filteredPosts = activeCategory === "All"
    ? blogPosts
    : blogPosts.filter(post => post.category === activeCategory);

  return (
    <main className="pt-20 md:pt-24 min-h-screen bg-gray-50">
      {/* Hero / Page Title */}
      <section
  className="relative text-white  md:py-0 overflow-hidden "
  style={{ backgroundImage: `url(${bgImage})` }}
>
  {/* Background overlay */}
  {/* <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-700/70"></div> */}

  <div className="relative container mx-auto px-4 flex flex-col md:flex-row items-center">
    
    {/* LEFT CONTENT */}
    <div className="md:w-1/2 text-center md:text-left z-10">
      <p className="text-lg uppercase tracking-wide text-blue-800 mb-2 font-bold">
        Blogs from
      </p>

      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
        Dr Arumalla Sridhar Reddy
      </h1>

      <p className="text-xl md:text-2xl opacity-90 mb-3">
        BDS, MDS – Oral & Maxillofacial Surgeon
      </p>

      <p className="text-lg text-blue-800 font-bold">
        Founder & Chairman
      </p>
    </div>

    {/* RIGHT DOCTOR IMAGE */}
    <div className=" mt-10 md:mt-0  justify-center md:justify-end ml-[15%] sm:mt-[10%]">
      <img
        src={doctorImage}
        alt="Dr Arumalla Sridhar Reddy"
        className="max-h-[350px] md:max-h-[420px] object-contain drop-shadow-2xl md:ml-[8%] "
      />
    </div>

  </div>
</section>

      {/* Main Content */}
      <section className="py-12 md:py-20">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-10">
            {/* Blog Posts Grid – Main Content */}
            <div className="lg:w-3/4">
              {/* Category Filter */}
              <div className="flex flex-wrap gap-3 mb-10">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    onClick={() => setActiveCategory(cat)}
                    className={`px-5 py-2 rounded-full text-sm font-medium transition ${
                      activeCategory === cat
                        ? "bg-blue-600 text-white shadow-md"
                        : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
                    }`}
                  >
                    {cat}
                  </button>
                ))}
              </div>

              {/* Posts Grid */}
              {filteredPosts.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {filteredPosts.map((post) => (
                    <article
                      key={post.id}
                      className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col"
                    >
                      {/* Image */}
                      <div className="relative h-52 overflow-hidden">
                        <img
                          src={post.image}
                          alt={post.title}
                          className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500"
                        />
                        <span className="absolute top-4 left-4 bg-blue-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
                          {post.category}
                        </span>
                      </div>

                      {/* Content */}
                      <div className="p-6 flex flex-col flex-grow">
                        <div className="flex items-center text-sm text-gray-500 mb-3">
                          <span>{post.date}</span>
                          <span className="mx-2">•</span>
                          <span>{post.readTime}</span>
                        </div>

                        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 line-clamp-2">
                          {post.title}
                        </h2>

                        <p className="text-gray-600 mb-6 line-clamp-3 flex-grow">
                          {post.excerpt}
                        </p>

                        <Link
                          // ← you can create dynamic blog post pages later
                          className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-800 mt-auto group"
                        >
                          Read More
                          <span className="ml-2 transform group-hover:translate-x-1 transition-transform">→</span>
                        </Link>
                      </div>
                    </article>
                  ))}
                </div>
              ) : (
                <div className="text-center py-20 text-gray-500 text-xl">
                  No posts found in this category.
                </div>
              )}

              {/* Pagination (simple) */}
              <div className="flex justify-center mt-12 gap-3">
                <button className="px-5 py-3 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
                  Previous
                </button>
                <button className="px-5 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                  1
                </button>
                <button className="px-5 py-3 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                  2
                </button>
                <button className="px-5 py-3 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                  Next
                </button>
              </div>
            </div>

            {/* Sidebar */}
            <aside className="lg:w-1/4 space-y-10">
              {/* Search */}
              <div className="bg-white p-6 rounded-2xl shadow-md">
                <h3 className="text-xl font-bold mb-4">Search Posts</h3>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search articles..."
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <svg
                    className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </div>

              {/* Recent Posts */}
              <div className="bg-white p-6 rounded-2xl shadow-md">
                <h3 className="text-xl font-bold mb-6">Recent Posts</h3>
                <div className="space-y-6">
                  {blogPosts.slice(0, 4).map((post) => (
                    <div key={post.id} className="flex gap-4">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-20 h-20 object-cover rounded-lg"
                      />
                      <div>
                        <Link
                          to={`/blog/${post.id}`}
                          className="font-medium text-gray-900 hover:text-blue-600 line-clamp-2"
                        >
                          {post.title}
                        </Link>
                        <p className="text-sm text-gray-500 mt-1">{post.date}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Categories */}
              <div className="bg-white p-6 rounded-2xl shadow-md">
                <h3 className="text-xl font-bold mb-6">Categories</h3>
                <ul className="space-y-3">
                  {categories.slice(1).map((cat) => (
                    <li key={cat}>
                      <button
                        onClick={() => setActiveCategory(cat)}
                        className={`text-gray-700 hover:text-blue-600 transition flex items-center ${
                          activeCategory === cat ? "font-semibold text-blue-600" : ""
                        }`}
                      >
                        <span className="w-2 h-2 bg-blue-600 rounded-full mr-3"></span>
                        {cat}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Blog;